import { useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { IconButton } from "@mui/material";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import {
  IMath,
  MATH_OPERATOR_LABELS,
  MathOperator,
} from "../../../models/interactions/Math";
import useUpdateSequenceInteraction from "../node_previews/UpdateSequenceInteraction.hook";
import classNames from "classnames";

export default function MathOperatorDropdown({
  nodeId,
  interaction,
}: {
  nodeId: string;
  interaction: IMath;
}) {
  const { updateInteraction } = useUpdateSequenceInteraction();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className="noDrag">
      <DropdownMenu.Root
        open={dropdownOpen}
        onOpenChange={setDropdownOpen}
        modal={false}
      >
        <DropdownMenu.Trigger asChild>
          <IconButton size="small" className="!p-0 !min-w-0">
            <ChangeCircleOutlinedIcon
              className="text-creator-primary"
              sx={{ fontSize: 20 }}
            />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            align="end"
            className="flex flex-col max-h-[200px] pit-creator-scrollbar overflow-y-auto bg-creator-surface overflow-x-hidden rounded-[10px] shadow-lg z-40"
            style={{
              padding: "6px",
              minWidth: "160px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            }}
            onWheel={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            onPointerMove={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            sideOffset={5}
          >
            {Object.entries(MATH_OPERATOR_LABELS).map(([op, label]) => (
              <DropdownMenu.Item
                key={op}
                className="rounded-md transition-colors cursor-pointer focus:outline-none"
                onSelect={() => {
                  updateInteraction(nodeId, {
                    ...interaction,
                    operator: op as MathOperator,
                  } as IMath);
                  setDropdownOpen(false);
                }}
              >
                <div
                  className={classNames(
                    "flex items-center px-3 py-2 hover:bg-creator-primary-background rounded-md",
                    interaction.operator === op && "bg-creator-primary-background"
                  )}
                >
                  <span className="text-[14px] font-medium text-creator-text-sub font-poppins">
                    {label}
                  </span>
                </div>
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
}
